module.exports = __webpack_public_path__ + "img/logo_title.b29c3e57.png";